import { Card, CardContent } from "@/components/ui/card";
import { SrIcon } from "@/components/ui/SrIcon";
import { WidgetAdminEditor } from "./WidgetAdminEditor";

export function WidgetsCard() {
  return (
    <Card id="widgets">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <SrIcon name="layout-grid" className="h-4 w-4 text-muted-foreground" />
          <h2 className="font-display text-base">
            Widgets — synlighet per rolle og ansatt
          </h2>
        </div>
        <WidgetAdminEditor />
      </CardContent>
    </Card>
  );
}
